import { Container, Row, Col } from "react-bootstrap";
import "../../../assets/css/customer/screens/home/Deals.css";

const deals = [
  {
    id: 1,
    badge: "Bestseller",
    discount: "25% OFF",
    name: "Glow Skin Package",
    desc: "Hydrafacial + Brightening boost + LED therapy.",
  },
  {
    id: 2,
    badge: "Bundle",
    discount: "30% OFF",
    name: "Laser Hair Removal Bundle",
    desc: "6 full-body sessions, prepaid.",
  },
  {
    id: 3,
    badge: "Limited",
    discount: "20% OFF",
    name: "Acne Clear Plan",
    desc: "3-month dermatologist-led acne protocol.",
  },
  {
    id: 4,
    badge: "New patients",
    discount: "FREE",
    name: "First Visit Consultation",
    desc: "Skin analysis + custom plan on your first visit.",
  },
];

const EstaticeDeals = () => {
  return (
    <section className="ac-deals">
      <Container className="ac-deals__container">

        {/* Header */}
        <div className="ac-deals__header">
          <span className="ac-deals__label">LIMITED TIME</span>
          <h2 className="ac-deals__heading">Skin & laser deals</h2>
        </div>

        {/* Cards Row */}
        <Row className="ac-deals__row">
          {deals.map((deal) => (
            <Col lg={3} md={6} sm={6} xs={12} key={deal.id} className="ac-deals__col">
              <div className="ac-deals__card">
                {/* Badge */}
                <span className="ac-deals__badge">{deal.badge}</span>
                {/* Discount */}
                <p className="ac-deals__discount">{deal.discount}</p>
                {/* Name */}
                <h6 className="ac-deals__name">{deal.name}</h6>
                {/* Desc */}
                <p className="ac-deals__desc">{deal.desc}</p>
              </div>
            </Col>
          ))}
        </Row>

      </Container>
    </section>
  );
};

export default EstaticeDeals;